function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { VNode } from 'snabbdom';
import { CheckboxEl } from 'common/components/checkbox';
import { filterAttributes } from 'common/util';
import { SvgIconEl } from 'common/components/svg-icon';
// eslint-disable-next-line import/no-cycle
import { ItemsMenuEl } from 'common/components/items-menu';
import { EventHandler, ItemAndEventHandler, ItemHandler, Section, SectionItemContextPanelTransform, SelectedTheme, SubLabelTheme, WrappedSection, WrappedSectionItem } from 'common/components/items-menu/types';
import { DropMenuEl } from 'common/components/drop-menu';
import { Directions, PositionParentType } from 'common/components/drop-menu/types';
import { ExperimentalTooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
import { SIZE, TEXT_HIGHLIGHT_THEME, TextHighlightEl } from 'common/components/text-highlight';
import { LocalizationStore } from 'common/i18n/store';
const Label = _ref => {
  let {
    label,
    labelMatches,
    showMatches
  } = _ref;
  if (labelMatches && showMatches) {
    return <span sel='.label'>
        {labelMatches.map(part => <span sel='.match-part'>{part}</span>)}
      </span>;
  }
  return <span sel='.label' data-sentry-component="Label" data-sentry-source-file="index.tsx">{label}</span>;
};
const UserControlWrapper = (_ref2: {
  isCheckbox: boolean;
  isCheckmark: boolean;
  isAnchorLink: boolean;
  isFocused: boolean;
  item: WrappedSectionItem;
}, children: VNode | VNode[]) => {
  let {
    isFocused,
    isCheckbox,
    isCheckmark,
    isAnchorLink,
    item
  }: {
    isCheckbox: boolean;
    isCheckmark: boolean;
    isAnchorLink: boolean;
    isFocused: boolean;
    item: WrappedSectionItem;
  } = _ref2;
  const sectionItem = item.wrapped;
  if (isCheckbox) {
    return <CheckboxEl attrs={filterAttributes({
      elref: "checkbox",
      checked: sectionItem.isSelected,
      /** if color is not provided, will be standard $blue1 */
      'checked-color': sectionItem.isSelectAll || sectionItem.isSelectAllMatching ? "none" : sectionItem.color || null,
      disabled: sectionItem.isDisabled,
      'unchecked-icon': sectionItem.isSelectAll || sectionItem.isSelectAllMatching ? "dash" : "",
      focused: isFocused
    })}>
        {children}
      </CheckboxEl>;
  }
  if (isCheckmark) {
    return <>
        <div sel='.checkmark-icon.item-icon'>
          <SvgIconEl attrs={{
          icon: "checkmark",
          empty: !item.wrapped.isSelected
        }} />
        </div>
        {children}
      </>;
  }
  if (isAnchorLink) {
    return <a sel='.list-option-link' attrs={{
      href: sectionItem.href,
      target: sectionItem.target
    }}>
        {children}
      </a>;
  }
  return <>{children}</>;
};
const SectionItemIcon = (_ref3: {
  item: WrappedSectionItem;
  alignAllText: boolean;
  iconRenderer: WrappedSection[`iconRenderer`];
  selectedTheme: SelectedTheme;
}) => {
  let {
    item,
    alignAllText,
    iconRenderer,
    selectedTheme
  }: {
    item: WrappedSectionItem;
    alignAllText: boolean;
    iconRenderer: WrappedSection[`iconRenderer`];
    selectedTheme: SelectedTheme;
  } = _ref3;
  const sectionItem = item.wrapped;
  const listIcon = sectionItem.icon;
  if (typeof iconRenderer === "function") {
    return <div sel='.custom-icon.item-icon'>{iconRenderer(sectionItem)}</div>;
  }
  return (listIcon || alignAllText) && <div sel='.option-icon.item-icon' attrs={{
    icon: listIcon
  }} class={{
    ["align-".concat(sectionItem.iconSide || "left")]: true,
    'align-top': Boolean(sectionItem.subLabel) && ![SelectedTheme.Checkbox, SelectedTheme.Checkmark].includes(selectedTheme),
    highlighted: sectionItem.highlightIcon
  }}>
        <SvgIconEl attrs={{
      icon: listIcon,
      empty: !listIcon || sectionItem.hideIcon
    }} />
      </div>;
};
const SectionItemLabel = (_ref4: {
  item: WrappedSectionItem;
  showMatches: boolean;
  i18n: LocalizationStore;
}) => {
  var _item$subLabelMatch, _item$labelMatch, _sectionItem$expansio, _sectionItem$expansio2, _item$subLabelMatch2;
  let {
    item,
    showMatches,
    i18n
  }: {
    item: WrappedSectionItem;
    showMatches: boolean;
    i18n: LocalizationStore;
  } = _ref4;
  const sectionItem = item.wrapped;
  const {
    print
  } = i18n;
  const subLabel = print(sectionItem.subLabel);
  return <>
      <div sel='.option-label-section' class={{
      ["sublabel-theme-".concat(sectionItem.subLabelTheme)]: Boolean(sectionItem.subLabelTheme),
      'has-sublabel': Boolean(subLabel)
    }}>
        <div sel='.option-label-container'>
          <div sel='.option-label' attrs={{
          title: print(sectionItem.label)
        }} class={{
          ["theme-".concat(sectionItem.labelTheme)]: Boolean(sectionItem.labelTheme),
          truncate: !sectionItem.wrapLabel
        }}>
            {subLabel && sectionItem.subLabelTheme === SubLabelTheme.Breadcrumb && <span sel='.option-label-path-prefix'>
                <Label label={subLabel} labelMatches={(_item$subLabelMatch = item.subLabelMatch) === null || _item$subLabelMatch === void 0 ? void 0 : _item$subLabelMatch.matchParts} showMatches={showMatches} />
              </span>}
            <Label label={print(sectionItem.label)} labelMatches={(_item$labelMatch = item.labelMatch) === null || _item$labelMatch === void 0 ? void 0 : _item$labelMatch.matchParts} showMatches={showMatches} data-sentry-element="Label" data-sentry-source-file="index.tsx" />
            {Boolean(sectionItem.tag) && <span sel='.tag-wrapper'>
                <TextHighlightEl attrs={{
              text: sectionItem.tag,
              size: SIZE.SMALL,
              theme: TEXT_HIGHLIGHT_THEME.INFORMATION
            }} />
              </span>}
          </div>
          {((_sectionItem$expansio = sectionItem.expansionToggle) === null || _sectionItem$expansio === void 0 ? void 0 : _sectionItem$expansio.labelSuffix) && <div sel='.label-suffix.item-icon'>
              <ExperimentalTooltipEl attrs={_objectSpread({
            placement: Placement.Top
          }, (_sectionItem$expansio2 = sectionItem.expansionToggle.labelSuffix.tooltip) !== null && _sectionItem$expansio2 !== void 0 ? _sectionItem$expansio2 : {})} />
              <SvgIconEl attrs={{
            icon: sectionItem.expansionToggle.labelSuffix.icon
          }} />
            </div>}
        </div>
        {subLabel && sectionItem.subLabelTheme !== SubLabelTheme.Breadcrumb && <div sel='.option-sub-label' attrs={{
        title: subLabel
      }} class={{
        ["theme-".concat(sectionItem.subLabelTheme)]: Boolean(sectionItem.subLabelTheme),
        truncate: !sectionItem.wrapSubLabel
      }}>
            <Label label={subLabel} labelMatches={(_item$subLabelMatch2 = item.subLabelMatch) === null || _item$subLabelMatch2 === void 0 ? void 0 : _item$subLabelMatch2.matchParts} showMatches={showMatches} />
            {sectionItem.subLabelBadge && <span sel='.option-sub-label-badge'>{sectionItem.subLabelBadge}</span>}
          </div>}
      </div>
      {sectionItem.sideLabel && <span sel='.option-side-label'>{sectionItem.sideLabel}</span>}
    </>;
};
const SectionItemAction = (_ref5: {
  item: WrappedSectionItem;
  isFocused: boolean;
  isPillFocused: boolean;
  actionsRenderer: WrappedSection[`actionsRenderer`];
  onClick: ItemAndEventHandler;
  onMouseEnter: ItemHandler;
  onMouseLeave: ItemHandler;
  fullyShownSections: Obj<boolean>;
}) => {
  let {
    item,
    isFocused,
    isPillFocused,
    actionsRenderer,
    onClick,
    onMouseEnter,
    onMouseLeave,
    fullyShownSections
  }: {
    item: WrappedSectionItem;
    isFocused: boolean;
    isPillFocused: boolean;
    actionsRenderer: WrappedSection[`actionsRenderer`];
    onClick: ItemAndEventHandler;
    onMouseEnter: ItemHandler;
    onMouseLeave: ItemHandler;
    fullyShownSections: Obj<boolean>;
  } = _ref5;
  const sectionItem = item.wrapped;
  if (typeof actionsRenderer === "function") {
    return <div sel='.custom-actions'>{actionsRenderer(sectionItem)}</div>;
  }
  if (sectionItem.hasPill) {
    return <div sel='.right-side-icon.pill' class={{
      focused: isFocused && isPillFocused,
      disabled: sectionItem.isPillDisabled
    }} on={{
      click: !sectionItem.isPillDisabled ? ev => onClick === null || onClick === void 0 ? void 0 : onClick(item, ev) : null,
      mouseenter: () => onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(item),
      mouseleave: () => onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(item)
    }}>
        <span>{sectionItem.pillLabel}</span>
        <div sel='.pill-caret.item-icon'>
          <SvgIconEl attrs={{
          icon: "caret-right"
        }} />
        </div>
      </div>;
  }
  if (sectionItem.subSections && sectionItem.subSections.length || sectionItem.hasCaret) {
    return <div sel='.right-side-icon.item-icon' class={{
      persistent: sectionItem.persistCaret
    }}>
        <SvgIconEl attrs={{
        icon: sectionItem.caretStyle === "arrow" ? "arrow-right" : "caret-right"
      }} />
      </div>;
  }
  if (sectionItem.isExpander && sectionItem.tooltip) {
    var _sectionItem$tooltip;
    return <div sel='.right-side-icon.item-icon.persistent'>
        <ExperimentalTooltipEl attrs={_objectSpread({
        placement: Placement.RightCenter
      }, (_sectionItem$tooltip = sectionItem.tooltip) !== null && _sectionItem$tooltip !== void 0 ? _sectionItem$tooltip : {})} />
        <SvgIconEl attrs={{
        icon: "info"
      }} />
      </div>;
  }
  if (sectionItem.expansionToggle) {
    return <div sel='.right-side-icon.item-icon.persistent'>
        <SvgIconEl attrs={{
        icon: fullyShownSections[item.sectionIndex] ? "caret-down" : "caret-right"
      }} />
      </div>;
  }
  return null;
};
export const SectionItemEl = (_ref6: {
  item: WrappedSectionItem;
  selectedTheme: SelectedTheme;
  alignAllText: boolean;
  isFocused: boolean;
  isPillFocused: boolean;
  showMatches: boolean;
  iconRenderer: WrappedSection[`iconRenderer`];
  actionsRenderer: WrappedSection[`actionsRenderer`];
  onActionClick: ItemAndEventHandler;
  onActionMouseEnter: ItemHandler;
  onActionMouseLeave: ItemHandler;
  fullyShownSections: Obj<boolean>;
  i18n: LocalizationStore;
}, sectionItemSubMenuChild: VNode) => {
  let {
    item,
    selectedTheme,
    alignAllText,
    isFocused,
    isPillFocused,
    showMatches,
    iconRenderer,
    actionsRenderer,
    onActionClick,
    onActionMouseEnter,
    onActionMouseLeave,
    fullyShownSections,
    i18n
  }: {
    item: WrappedSectionItem;
    selectedTheme: SelectedTheme;
    alignAllText: boolean;
    isFocused: boolean;
    isPillFocused: boolean;
    showMatches: boolean;
    iconRenderer: WrappedSection[`iconRenderer`];
    actionsRenderer: WrappedSection[`actionsRenderer`];
    onActionClick: ItemAndEventHandler;
    onActionMouseEnter: ItemHandler;
    onActionMouseLeave: ItemHandler;
    fullyShownSections: Obj<boolean>;
    i18n: LocalizationStore;
  } = _ref6;
  const sectionItem = item.wrapped;
  let isCheckbox = false;
  let isCheckmark = false;
  if (!sectionItem.isExpander && !sectionItem.expansionToggle && !sectionItem.isControlItem) {
    isCheckbox = selectedTheme === SelectedTheme.Checkbox;
    isCheckmark = selectedTheme === SelectedTheme.Checkmark;
  }
  const isAnchorLink = Boolean(sectionItem.href);
  return <UserControlWrapper isCheckbox={isCheckbox} isCheckmark={isCheckmark} isAnchorLink={isAnchorLink} isFocused={isFocused} item={item} data-sentry-element="UserControlWrapper" data-sentry-component="SectionItemEl" data-sentry-source-file="index.tsx">
      <SectionItemIcon item={item} alignAllText={alignAllText} iconRenderer={iconRenderer} selectedTheme={selectedTheme} data-sentry-element="SectionItemIcon" data-sentry-source-file="index.tsx" />
      {item.wrapped.label && <SectionItemLabel item={item} showMatches={showMatches} i18n={i18n} />}
      <SectionItemAction item={item} isFocused={isFocused} isPillFocused={isPillFocused} onClick={onActionClick} onMouseEnter={onActionMouseEnter} onMouseLeave={onActionMouseLeave} actionsRenderer={actionsRenderer} fullyShownSections={fullyShownSections} data-sentry-element="SectionItemAction" data-sentry-source-file="index.tsx" />
      {sectionItemSubMenuChild}
    </UserControlWrapper>;
};
export const SectionItemSubMenuEl = (_ref7: {
  alignAllText: boolean;
  selectedTheme: SelectedTheme;
  contextPanelTransform: SectionItemContextPanelTransform;
  keydownProxyEl: HTMLElement;
  onNavigateBack: () => void;
  onClickItem: EventHandler;
  onFocusItem: EventHandler;
  onMouseEnter: (ev: MouseEvent) => void;
  sections?: Section[];
}) => {
  let {
    alignAllText,
    selectedTheme,
    contextPanelTransform,
    keydownProxyEl,
    onNavigateBack,
    onClickItem,
    onFocusItem,
    onMouseEnter,
    sections
  }: {
    alignAllText: boolean;
    selectedTheme: SelectedTheme;
    contextPanelTransform: SectionItemContextPanelTransform;
    keydownProxyEl: HTMLElement;
    onNavigateBack: () => void;
    onClickItem: EventHandler;
    onFocusItem: EventHandler;
    onMouseEnter: (ev: MouseEvent) => void;
    sections?: Section[];
  } = _ref7;
  return <DropMenuEl sel='.option-subsections' attrs={{
    open: true,
    offset: 10,
    direction: Directions.Right
  }} props={{
    // place the dropdown relative to the parent element as opposed to its offset parent
    positionParent: PositionParentType.ParentElement
  }} on={{
    mouseenter: onMouseEnter,
    click: ev => {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }} data-sentry-element="DropMenuEl" data-sentry-component="SectionItemSubMenuEl" data-sentry-source-file="index.tsx">
      <ItemsMenuEl attrs={{
      elref: "nestedList",
      'selected-theme': selectedTheme,
      'align-all-text': alignAllText,
      'disable-auto-focus': true
    }} props={{
      sections,
      contextPanelTransform,
      keydownProxyEl
    }} on={{
      navigateBack: () => onNavigateBack(),
      clickItem: onClickItem,
      focusItem: onFocusItem
    }} data-sentry-element="ItemsMenuEl" data-sentry-source-file="index.tsx" />
    </DropMenuEl>;
};